/**
 * Tipos de menu
 */
export enum TYPE_MENU {
  oneMenu = 'oneMenu',
  twoMenu = 'twoMenu',
  threeMenu = 'threeMenu',
  fourMenu = 'fourMenu',
  imagesMenu = 'imagesMenu',
  imagesMenuEs = 'imagesMenuEs',
  imagesMenuEn = 'imagesMenuEn',
  // Este es un tipo de menu que se hizo para que no salgan las opciones en el sidemenu
  fourMenuWithOutSideMenu = 'fourMenuWithOutSideMenu',
}
/**
 * Tipos de pantalla de menu
 */
export enum TYPE_SCREEN {
  buttons = 'buttons',
  fullScreen = 'fullScreen',
  fullScreenButtons = 'fullScreenButtons',
}
/**
 * Tipos de plantilla de menu
 */
export enum TYPES_MENU {
  tabs = 'tabs',
  pdf = 'pdf',
  buttons = 'buttons',
  scroll = 'scroll',
}
/**
 * Listado de tipos de pantalla de meunu
 */
export const LIST_TYPES_SCREEN = [
  { key: TYPE_SCREEN.buttons, label: 'Botones personalizados' },
  { key: TYPE_SCREEN.fullScreen, label: 'Fondo pantalla completa' },
  { key: TYPE_SCREEN.fullScreenButtons, label: 'Fondo con botones de imagen' },
];
/**
 * Tipos de secciones para menu
 */
export enum TYPE_SECTIONS {
  productsMenu = 'productsMenu',
  productList = 'productList',
  productsOnlyPhoto = 'productsOnlyPhoto',
  drinks = 'drinks',
  wines = 'wines',
  gallery = 'gallery',
  videos = 'videos',
  drinks_midle = 'drinks_midle',
  productSimpleList = 'simpleList',
  onlyDescription = 'onlyDescription',
  additions = 'additions',
  separator = 'separator'

}
/**
 * Listado de tipos de visibilidad de menu
 */
export enum VISIBILITY_ITEM {
  restaurant = 'R',
  delivery = 'D',
  restaurantAndDelivery = 'RD'
};

/**
 * Listado de tipos de visibilidad de menu
 */
export enum TYPE_PRODUCT {
  hot = 'hot',
  late = 'late',
  vegan = 'vegan',
  vegetarian = 'vegetarian',
  gluten = 'gluten'
};

/**
 * Listado de modulos activos en un restaurante
 */
export enum TYPE_SERVICES {
  reserve = 'R',
  delivery = 'D',
  reserveDelivery = 'RD',
  roomService = 'RO'
};
